import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:brand/vulnerability-disclosure-policy',
      name: 'DisclosurePolicy',
      component: () => import('../views/VulnerabilityDisclosurePolicy.vue')
    },
    {
      path: '/:brand/vulnerability-management',
      name: 'VulnerabilityManagement',
      component: () => import('../views/VulnerabilityManagement.vue')
    },
    {
      path: '/vulnerability-disclosure-policy',
      redirect: '/eufy/vulnerability-disclosure-policy'
    },
    {
      path: '/vulnerability-management',
      redirect: '/eufy/vulnerability-management'
    },
    {
      path: '*',
      redirect: '/eufy/vulnerability-disclosure-policy'
    }
  ]
})
